import { render, staticRenderFns } from "./FranchiseesList.vue?vue&type=template&id=71d74e87&scoped=true"
import script from "./FranchiseesList.vue?vue&type=script&lang=js"
export * from "./FranchiseesList.vue?vue&type=script&lang=js"
import style0 from "./FranchiseesList.vue?vue&type=style&index=0&id=71d74e87&prod&lang=scss&scoped=true"
import style1 from "./FranchiseesList.vue?vue&type=style&index=1&id=71d74e87&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d74e87",
  null
  
)

export default component.exports